<template>
  <v-card class="h-100 card-border" @dblclick="$emit('dblclick')">
    <div class="preload-box h-100 pa-2" v-if="isLoading">
      <v-progress-circular indeterminate :size="loaderSize" color="primary"></v-progress-circular>
    </div>
    <v-layout row v-else-if="hasAccess">
      <v-flex xs12 class="text-md-left">
        <div class="d-flex justify-space-between align-center card-title px-4 py-2">
          <div class="d-flex align-center">
            <slot name="title"/>
          </div>
          <slot name="icon"/>
        </div>
        <slot/>
      </v-flex>
    </v-layout>
    <slot name="permissionDenied" v-if="!hasAccess"/>
  </v-card>
</template>
<script>
export default {
  props: {
    isLoading: {
      type:Boolean,
      default: false
    },
    loaderSize: {
      type:Number,
      default: 50
    },
    hasAccess: {
      type: Number,
      default: 0
    },
  }
}
</script>
<style scoped>
.card-border {
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  overflow: hidden;
}
.card-title {
  color: #8AA1AC;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  border-bottom: 1px solid #D9D9D9;
}.card-title {
   position: static !important;
 }
</style>
